import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1001Status: 'idle',
    startProcess1001Error: undefined as any,
    loadUserParamsProcess1001Status: 'idle',
    loadUserParamsProcess1001Error: undefined as any,

    process1001List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1001 = createAsyncThunk('process1001Slice/startProcess1001', async ({ process1001 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1001/`,
        prepareData(process1001),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1001Status } = getState().process1001Slice
        return startProcess1001Status !== 'pending'
    }
})

export const loadUserParamsProcess1001 = createAsyncThunk('process1001Slice/loadUserParamsProcess1001', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1001/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1001Status } = getState().process1001Slice
        return loadUserParamsProcess1001Status !== 'pending'
    }
})

const Process1001Slice = createSlice({
    name: 'process1001Slice',
    initialState,
    reducers: {
        resetstartProcess1001: (state) => {
            state.job = undefined
            state.startProcess1001Error = undefined
        },
        resetstartProcess1001Error: (state) => {
            state.startProcess1001Error = undefined
        },
        resetloadUserParamsProcess1001: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1001Error = undefined
        },
        resetloadUserParamsProcess1001Error: (state) => {
            state.loadUserParamsProcess1001Error = undefined
        },
        removeFromProcess1001ListById: (state, action) => {
            state.process1001List = state.process1001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1001ListByIds: (state, action) => {
            state.process1001List = state.process1001List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1001List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1001Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1001List = []
            state.startProcess1001Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1001.pending, (state) => {
            state.startProcess1001Status = 'pending'
            state.startProcess1001Error = undefined
        })
        builder.addCase(startProcess1001.fulfilled, (state, action) => {
            state.startProcess1001Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1001.rejected, (state, action) => {
            state.startProcess1001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1001Error = action.error.message
            } else {
                state.startProcess1001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1001.pending, (state) => {
            state.loadUserParamsProcess1001Status = 'pending'
            state.loadUserParamsProcess1001Error = undefined
        })
        builder.addCase(loadUserParamsProcess1001.fulfilled, (state, action) => {
            state.loadUserParamsProcess1001Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1001.rejected, (state, action) => {
            state.loadUserParamsProcess1001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1001Error = action.error.message
            } else {
                state.loadUserParamsProcess1001Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1001,
    resetstartProcess1001Error,
    resetloadUserParamsProcess1001,
    resetloadUserParamsProcess1001Error,
    removeFromProcess1001ListById,
    removeFromProcess1001ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1001Slice.actions
export default Process1001Slice.reducer
